import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <div className="text-center">
        <div className="text-6xl mb-3">🔍</div>
        <h1 className="text-2xl font-bold text-slate-900 mb-2">Página no encontrada</h1>
        <p className="text-sm text-slate-500 mb-6">
          La ruta que buscas no existe o fue movida.
        </p>
        <Link
          to="/gestion/dashboard"
          className="inline-block px-6 py-2.5 rounded-lg bg-primary text-white font-semibold"
        >
          Ir al dashboard
        </Link>
      </div>
    </div>
  );
}